import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { saveAs } from 'file-saver';
import { LOCATION_CHANGE } from 'react-router-redux';
import ajax from '../shared/ajax';
import AppError from '../shared/AppError';
import {
  AJAX_DEBOUNCE_TIME,
  INVALID_TOKEN_CODE
} from '../shared/constants';
import actionsAndConstants from '../shared/actionsAndConstants';
import alertMessages from '../shared/alertMessages';

const {
  app: {
    actions: appActions,
    constants: appConstants
  }
} = actionsAndConstants;

const createTableData = action$ =>
  action$.ofType(appConstants.createTableData)
    .switchMap(({ meta: { tableName } = {}, payload: { ajaxOptions = {}, dialogId = '' } = {} }) =>
      ajax(ajaxOptions)
        .mergeMap(({ detalle, descripcion }) => (
          Observable.of(
            appActions.hideDialog({ id: dialogId }),
            appActions.createTableDataSucceeded({
              alert: {
                message: descripcion || alertMessages[tableName].create.succeeded,
                type: 'success'
              },
              data: detalle[0],
              tableName
            })
          )
        ))
        .catch((error) => {
          if (error instanceof AppError && error.code === INVALID_TOKEN_CODE) {
            return Observable.of(
              appActions.hideDialog({ id: dialogId }),
              appActions.invalidToken({
                alert: { message: error.description }
              })
            );
          }
          return Observable.of(
            appActions.hideDialog({ id: dialogId }),
            appActions.createTableDataFailed({
              alert: { message: error.description || error.message || alertMessages[tableName].create.failed },
              tableName
            })
          );
        }));

const deleteTableData = action$ =>
  action$.ofType(appConstants.deleteTableData)
    .switchMap(({ meta: { tableName } = {}, payload: { ajaxOptions = {}, dialogId = '' } = {} }) =>
      ajax(ajaxOptions)
        .mergeMap(({ detalle, descripcion }) => (
          Observable.of(
            appActions.hideDialog({ id: dialogId }),
            appActions.deleteTableDataSucceeded({
              alert: {
                message: descripcion || alertMessages[tableName].delete.succeeded,
                type: 'success'
              },
              data: detalle[0],
              tableName
            })
          )
        ))
        .catch((error) => {
          if (error instanceof AppError && error.code === INVALID_TOKEN_CODE) {
            return Observable.of(
              appActions.hideDialog({ id: dialogId }),
              appActions.invalidToken({
                alert: { message: error.description }
              })
            );
          }
          return Observable.of(
            appActions.hideDialog({ id: dialogId }),
            appActions.deleteTableDataFailed({
              alert: { message: error.description || error.message || alertMessages[tableName].delete.failed },
              tableName
            })
          );
        }));

const editTableData = action$ =>
  action$.ofType(appConstants.editTableData)
    .switchMap(({ meta: { tableName }, payload: { ajaxOptions = {}, dialogId = '' } = {} }) =>
      ajax(ajaxOptions)
        .mergeMap(({ detalle, descripcion }) => (
          Observable.of(
            appActions.hideDialog({ id: dialogId }),
            appActions.editTableDataSucceeded({
              alert: {
                message: descripcion || alertMessages[tableName].edit.succeeded,
                type: 'success'
              },
              data: detalle[0],
              tableName
            })
          )
        ))
        .catch((error) => {
          if (error instanceof AppError && error.code === INVALID_TOKEN_CODE) {
            return Observable.of(
              appActions.hideDialog({ id: dialogId }),
              appActions.invalidToken({
                alert: { message: error.description }
              })
            );
          }
          return Observable.of(
            appActions.hideDialog({ id: dialogId }),
            appActions.editTableDataFailed({
              alert: { message: error.description || error.message || alertMessages[tableName].edit.failed },
              tableName
            })
          );
        }));

const exportTableData = action$ =>
  action$.ofType(appConstants.exportTableData)
    .mergeMap(({ meta: { tableName }, payload: { ajaxOptions = {}, exportMode = '', filename = '', rowIndex = null } = {} }) =>
      ajax(ajaxOptions)
        .map((blob) => {
          try {
            saveAs(blob, filename);
          } catch (e) {
            throw new Error(alertMessages.export.failed);
          }
          return appActions.exportTableDataSucceeded({
            alert: {
              message: alertMessages.export.succeeded,
              type: 'success'
            },
            ...exportMode && { exportMode },
            ...(rowIndex >= 0) && { rowIndex },
            tableName
          });
        })
        .catch((error) => {
          if (error instanceof AppError && error.code === INVALID_TOKEN_CODE) {
            return Observable.of(
              appActions.invalidToken({
                alert: { message: error.description }
              })
            );
          }
          return Observable.of(
            appActions.exportTableDataFailed({
              alert: { message: error.description || error.message || alertMessages.export.failed },
              ...exportMode && { exportMode },
              ...(rowIndex >= 0) && { rowIndex },
              tableName
            })
          );
        }));

const loadTableData = action$ =>
  action$.ofType(appConstants.loadTableData)
    .debounceTime(AJAX_DEBOUNCE_TIME)
    .switchMap(({ meta: { tableName } = {}, payload: { ajaxOptions = {}, event = '' } = {} }) =>
      ajax(ajaxOptions)
        .map(({ resultDetail }) => appActions.loadTableDataSucceeded({
          data: resultDetail,
          ...event && { event },
          tableName
        }))
        .catch((error) => {
          if (error instanceof AppError && error.code === INVALID_TOKEN_CODE) {
            return Observable.of(appActions.invalidToken({
              alert: { message: error.description }
            }));
          }
          return Observable.of(appActions.loadTableDataFailed({
            alert: { message: error.description || error.message || alertMessages[tableName].load.failed },
            ...event && { event },
            tableName
          }));
        })
        .race(
          action$.ofType(LOCATION_CHANGE)
            .map(() => appActions.loadTableDataFailed({ event: 'locationChange', tableName }))
            .take(1)
        ));

const tableChangesSucceeded = action$ =>
  action$.filter(action => (action.type === appConstants.createTableDataSucceeded) || (action.type === appConstants.editTableDataSucceeded) || (action.type === appConstants.deleteTableDataSucceeded))
    .mergeMap(({ meta: { tableName } = {} }) => (
      Observable.of(
        appActions.reloadTableData({ tableName }),
        appActions.loadCatalogues()
      )
    ));

export default combineEpics(
  createTableData,
  deleteTableData,
  editTableData,
  exportTableData,
  loadTableData,
  tableChangesSucceeded
);



// WEBPACK FOOTER //
// ./src/epics/tables.js